import * as Business    from '../business';
import { getResources } from 'redux-resource';
import { getStatus }    from 'redux-resource';


export function getCampaigns(state, businessID) {
  const campaigns = getResources(state.campaigns, businessID);
  const team      = Business.getTeam(state, businessID);

  if (team)
    return campaigns.map(addNamesToUsers);
  else
    return campaigns;

  function addNamesToUsers(campaign) {
    return {
      ...campaign,
      user: {
        ...campaign.user,
        name: getUserName(campaign.user?.id)
      }
    };

    function getUserName(userID) {
      const teamUser = team.users.find(u => u.id === userID);
      return teamUser?.name;
    }
  }

}


function getCampaignsReadStatus(state, businessID) {
  return getStatus(state.campaigns, `requests.read-${businessID}.status`);
}


function getCampaignsReadStatusCode(state, businessID) {
  return state.campaigns.requests[`read-${businessID}`]?.statusCode;
}


export function getCampaignsStatuses(state, businessID) {
  return {
    createStatus:   {},
    deleteStatus:   {},
    readStatus:     getCampaignsReadStatus(state, businessID),
    readStatusCode: getCampaignsReadStatusCode(state, businessID),
    updateStatus:   {}
  };
}

export function getCampaign(state, campaignID) {
  return getResources(state.campaigns, [ campaignID ])[0];
}

export function getCampaignReadStatus(state, campaignID) {
  return getStatus(state.campaigns, `meta[${campaignID}].readStatus`);
}

export function getCampaignsCreateStatus(state, businessID) {
  return getStatus(state.campaigns, `requests.create-${businessID}.status`);
}

export function getCampaignUpdateStatus(state, campaignID) {
  return getStatus(state.campaigns, `meta[${campaignID}].updateStatus`);
}
